/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { GarageSpotAttributeDefinitionDtoToJSON, GarageSpotAttributeDefinitionDtoGenericApiResponseFromJSON, GarageSpotAttributeDefinitionDtoListGenericApiResponseFromJSON, GarageSpotAttributeDefinitionDtoSortedPagedListResponseGenericApiResponseFromJSON, Int32GenericApiResponseFromJSON, SuccessfullApiResponseFromJSON, } from '../models';
/**
 *
 */
export class GarageSpotAttributeDefinitionApi extends runtime.BaseAPI {
    /**
     */
    apiGarageSpotAttributeDefinitionAddPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/GarageSpotAttributeDefinition/Add`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: GarageSpotAttributeDefinitionDtoToJSON(requestParameters.garageSpotAttributeDefinitionDto),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => Int32GenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGarageSpotAttributeDefinitionAddPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGarageSpotAttributeDefinitionAddPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiGarageSpotAttributeDefinitionDeleteIdDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling apiGarageSpotAttributeDefinitionDeleteIdDelete.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/GarageSpotAttributeDefinition/Delete/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGarageSpotAttributeDefinitionDeleteIdDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGarageSpotAttributeDefinitionDeleteIdDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiGarageSpotAttributeDefinitionFindByGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.filtersName !== undefined) {
                queryParameters['Filters.Name'] = requestParameters.filtersName;
            }
            if (requestParameters.pageNumber !== undefined) {
                queryParameters['PageNumber'] = requestParameters.pageNumber;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['PageSize'] = requestParameters.pageSize;
            }
            if (requestParameters.sortPropertyName !== undefined) {
                queryParameters['SortPropertyName'] = requestParameters.sortPropertyName;
            }
            if (requestParameters.sortDirection !== undefined) {
                queryParameters['SortDirection'] = requestParameters.sortDirection;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/GarageSpotAttributeDefinition/FindBy`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GarageSpotAttributeDefinitionDtoSortedPagedListResponseGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGarageSpotAttributeDefinitionFindByGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGarageSpotAttributeDefinitionFindByGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiGarageSpotAttributeDefinitionGetAllGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.pageNumber !== undefined) {
                queryParameters['PageNumber'] = requestParameters.pageNumber;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['PageSize'] = requestParameters.pageSize;
            }
            if (requestParameters.sortPropertyName !== undefined) {
                queryParameters['SortPropertyName'] = requestParameters.sortPropertyName;
            }
            if (requestParameters.sortDirection !== undefined) {
                queryParameters['SortDirection'] = requestParameters.sortDirection;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/GarageSpotAttributeDefinition/GetAll`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GarageSpotAttributeDefinitionDtoSortedPagedListResponseGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGarageSpotAttributeDefinitionGetAllGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGarageSpotAttributeDefinitionGetAllGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiGarageSpotAttributeDefinitionGetCollectionAttributesCollectionIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.collectionId === null || requestParameters.collectionId === undefined) {
                throw new runtime.RequiredError('collectionId', 'Required parameter requestParameters.collectionId was null or undefined when calling apiGarageSpotAttributeDefinitionGetCollectionAttributesCollectionIdGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/GarageSpotAttributeDefinition/GetCollectionAttributes/{collectionId}`.replace(`{${"collectionId"}}`, encodeURIComponent(String(requestParameters.collectionId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GarageSpotAttributeDefinitionDtoListGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGarageSpotAttributeDefinitionGetCollectionAttributesCollectionIdGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGarageSpotAttributeDefinitionGetCollectionAttributesCollectionIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiGarageSpotAttributeDefinitionGetIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling apiGarageSpotAttributeDefinitionGetIdGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/GarageSpotAttributeDefinition/Get/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GarageSpotAttributeDefinitionDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGarageSpotAttributeDefinitionGetIdGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGarageSpotAttributeDefinitionGetIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiGarageSpotAttributeDefinitionUpdatePutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/GarageSpotAttributeDefinition/Update`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: GarageSpotAttributeDefinitionDtoToJSON(requestParameters.garageSpotAttributeDefinitionDto),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGarageSpotAttributeDefinitionUpdatePut(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGarageSpotAttributeDefinitionUpdatePutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
